const WILDCARD = '*';

export function can(permissions: string[], key: string): boolean {
  return permissions.includes(WILDCARD) || permissions.includes(key);
}
